export var capitalize = function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(void 0, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(void 0, args);
  };
};
export var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
export var flatten = function flatten(array) {
  return array.reduce(function (acc, val) {
    return acc.concat(val);
  }, []);
};
export var isMobile = function isMobile() {
  return navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i);
};